import { z } from 'zod';

export const realtimeIDVerificationSchema = z.object({
    idNumber: z.string({ error: 'ID Number is required' })
        .regex(/^\d+$/, "ID Number must be numeric"),
    firstName: z.string().optional().or(z.literal('')),
    surname: z.string().optional().or(z.literal('')),
    yourReference: z.string().optional().or(z.literal('')),
    voucherCode: z.string().optional().or(z.literal('')),
});

export type RealtimeIDVerificationPayload = z.infer<typeof realtimeIDVerificationSchema>;

export const realtimeIDVerificationService = {
    createPayload: (formData: z.infer<typeof realtimeIDVerificationSchema>): RealtimeIDVerificationPayload => {
        return {
            ...formData
        };
    },

    executeReport: async (payload: RealtimeIDVerificationPayload): Promise<any> => {
        const axios = (await import('../axiosConfig')).default;
        const response = await axios.post('/verification/realtime-id-verification', payload);
        return response.data;
    }
};
